import axios from 'axios';
import {
    removeErrors,
    validate,
    makeFormData,
    serialize,
    addFiles,
    uploadFile,
} from './form';

export default class ContactForm {
    private selector: HTMLFormElement;

    constructor(selector: string) {
        this.selector = document.querySelector(selector);
        if (this.selector) {
            this.init();
        }
    }

    private init(): void {
        const button: HTMLElement = this.selector.querySelector('[data-form-file-button]');
        if (button) {
            uploadFile(button);
        }

        removeErrors(this.selector);

        this.selector.addEventListener('submit', this.submitForm.bind(this));
    }

    private submitForm(e: Event): void {
        e.preventDefault();

        const form = e.target as HTMLFormElement;
        const modal: HTMLElement = form.closest('[data-modal-container]');
        const modalSuccess: HTMLElement = modal.querySelector('[data-modal-success]');
        const modalContent: HTMLElement = modal.querySelector('[data-modal-content]');
        const button: HTMLElement = form.querySelector('[data-form-button]');
        const valid = validate(form);

        if (valid) {
            button.classList.add('button--disabled');

            let data: FormData = makeFormData(serialize(form));
            data = addFiles(form, data);

            axios({
                method: 'POST',
                url: form.action,
                data,
            }).then(() => {
                modalContent.classList.remove('modal__container--show');
                modalSuccess.classList.add('modal__success--show');
            });
        }
    }
}
